import { Box } from "@mui/material";
import { sessionCard } from "./styles";

const SessionCard = ({ children }) => {
  return <Box sx={(theme) => sessionCard(theme)}>{children}</Box>;
};

export default SessionCard;
